import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconMap = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
      >
        <path
          d="M20.3799 21.13C20.1799 21.13 19.9899 21.05 19.8499 20.91L13.4699 14.53C13.1799 14.24 13.1799 13.76 13.4699 13.47L21.2 5.74001C21.39 5.55001 21.6799 5.48001 21.9399 5.55001C22.1999 5.63001 22.3999 5.84001 22.4599 6.10001C22.6499 6.95001 22.7499 7.90001 22.7499 9.00001V15C22.7499 17.77 22.1699 19.64 20.9099 20.91C20.7699 21.05 20.5599 21.08 20.3799 21.13ZM15.0599 14L20.3199 19.26C20.9499 18.29 21.2499 16.91 21.2499 15V9.00001C21.2499 8.59 21.2399 8.21001 21.2099 7.85001L15.0599 14Z"
          fill={color}
        />
        <path
          d="M6.26999 22.48C6.20999 22.48 6.16001 22.47 6.10001 22.46C2.79001 21.7 1.25 19.33 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C19.33 1.25 21.6999 2.79001 22.4599 6.10001C22.5199 6.35001 22.44 6.62 22.26 6.8L6.79999 22.26C6.65999 22.4 6.46999 22.48 6.26999 22.48ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 18.47 3.71001 20.21 6.04001 20.9L20.89 6.05C20.21 3.72 18.46 2.75999 14.99 2.75999H9V2.75Z"
          fill={color}
        />
        <path
          d="M14.9999 22.7504H8.99989C7.89989 22.7504 6.96001 22.66 6.10001 22.46C5.83001 22.4 5.61987 22.2004 5.54987 21.9404C5.46987 21.6804 5.54988 21.4004 5.73988 21.2004L13.4699 13.47C13.7599 13.18 14.2399 13.1804 14.5299 13.4704L20.9099 19.8504C21.0499 19.9904 21.1299 20.1804 21.1299 20.3804C21.1299 20.5804 21.0499 20.77 20.9099 20.91C19.6399 22.17 17.7699 22.7504 14.9999 22.7504ZM7.84989 21.2104C8.20989 21.2404 8.58989 21.2504 8.99989 21.2504H14.9999C16.9199 21.2504 18.2899 20.9504 19.2599 20.3204L13.9999 15.0604L7.84989 21.2104Z"
          fill={color}
        />
        <path
          d="M9.11994 13.31C8.48994 13.31 7.85993 13.08 7.35993 12.61C5.76993 11.1 5.12996 9.44005 5.50996 7.82005C5.88996 6.16005 7.33994 5.04004 9.11994 5.04004C10.8999 5.04004 12.35 6.16005 12.73 7.82005C13.1 9.45005 12.4599 11.1 10.8699 12.61C10.3799 13.07 9.74994 13.31 9.11994 13.31ZM6.96995 8.15004C6.64995 9.51004 7.56994 10.7301 8.39994 11.5201C8.80994 11.91 9.43994 11.91 9.83994 11.5201C10.6599 10.7401 11.5799 9.52004 11.2699 8.15004C10.9999 6.96004 9.93994 6.53004 9.11994 6.53004C8.29994 6.53004 7.24995 6.96004 6.96995 8.15004Z"
          fill={color}
        />
        <path
          d="M9.1499 9.49023C8.5999 9.49023 8.1499 9.04023 8.1499 8.49023C8.1499 7.94023 8.5899 7.49023 9.1499 7.49023H9.15991C9.70991 7.49023 10.1599 7.94023 10.1599 8.49023C10.1599 9.04023 9.6999 9.49023 9.1499 9.49023Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
